import 'jquery';

export default () => {

    const specialBanners = $(document).find('.banner_wrapper');

    specialBanners.each(function (index, banner) {

        if (!$(banner).find('.attachment-full').length) {
            $(banner).addClass('no-img');
        }
    });


};


// WEBPACK FOOTER //
// ./scripts/modules/banners.js